"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _baseRouter = _interopRequireDefault(require("./components/base-router"));

var _bootstrapperWithoutRouter = _interopRequireDefault(require("./bootstrapper-without-router"));

var _routerReducer = _interopRequireDefault(require("./reducers/router-reducer"));

var _reducerRegistry = require("@eig-builder/core-utils/reducer-registry");

(0, _reducerRegistry.registerReducer)('router', _routerReducer["default"]);

var EmptyBaseRouterWrapper = function EmptyBaseRouterWrapper(props) {
  return props.children;
};

EmptyBaseRouterWrapper.propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node])
};

var Bootstrapper =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(Bootstrapper, _PureComponent);

  function Bootstrapper() {
    (0, _classCallCheck2["default"])(this, Bootstrapper);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bootstrapper).apply(this, arguments));
  }

  (0, _createClass2["default"])(Bootstrapper, [{
    key: "render",
    value: function render() {
      var BaseRouterWrapper = this.props.BaseRouterWrapper || EmptyBaseRouterWrapper;
      var events = [{
        type: 'AVAILABLE_ROUTES',
        payload: this.props.routes,
        basename: this.props.basename
      }];
      return _react["default"].createElement(_bootstrapperWithoutRouter["default"], (0, _extends2["default"])({
        eventsToDispatch: events
      }, this.props), _react["default"].createElement(BaseRouterWrapper, null, _react["default"].createElement(_baseRouter["default"], {
        defaultRoute: this.props.defaultRoute,
        routes: this.props.routes,
        basename: this.props.basename,
        loginUrl: this.props.loginUrl,
        appWrapper: this.props.appWrapper
      })));
    }
  }]);
  return Bootstrapper;
}(_react.PureComponent);

Bootstrapper.propTypes = {
  defaultRoute: _propTypes["default"].string.isRequired,
  basename: _propTypes["default"].string,
  routes: _propTypes["default"].array.isRequired,
  loginUrl: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func]),
  BaseRouterWrapper: _propTypes["default"].any,
  appWrapper: _propTypes["default"].any
};
var _default = Bootstrapper;
exports["default"] = _default;